import TripChatMobileAppShell from '../mobile/TripChatMobileAppShell'

function TripChatMobileSurface() {
  return <TripChatMobileAppShell />
}

export default TripChatMobileSurface
